<template>
  <v-app>
    <v-main>
      YO
    </v-main>
  </v-app>
</template>

<script>

export default {
  name: 'App',

  components: {
   
  },

  data: () => ({
    //
  }),
}
</script>
